import React from 'react';

import { motion } from 'framer-motion';
import './PageNavigation.scss';

export interface Tab {
  id: string;
  label: string;
}

interface PageNavigationProps {
  activeTab: string;
  onTabChange: (tabId: string) => void;
  tabs: Tab[];
}

export const PageNavigation: React.FC<PageNavigationProps> = ({
  activeTab,
  onTabChange,
  tabs
}) => {


  return (
    <nav className="page-navigation">
      {tabs.map((tab) => (
        <button
          key={tab.id}
          className={`page-navigation__tab ${
            activeTab === tab.id ? 'page-navigation__tab--active' : ''
          }`}
          onClick={() => onTabChange(tab.id)}
          aria-selected={activeTab === tab.id}
          role="tab"
        >
          {tab.label}
          <motion.div 
            className="page-navigation__tab-indicator"
            initial={{ opacity: 0, scaleX: 0 }}
            animate={{ 
              opacity: activeTab === tab.id ? 1 : 0,
              scaleX: activeTab === tab.id ? 1 : 0
            }}
            transition={{ 
              duration: 0.3,
              ease: [0.4, 0, 0.2, 1]
            }}
          />
        </button>
      ))}
    </nav>
  );
};
